module.exports = __webpack_public_path__ + "img/avatar.b4afb0f7.png";